/* eslint-disable import/prefer-default-export */
export enum ApplicationStage {
    OnHold = 'On Hold',
    ContactMade = 'Contact Made',
    EnquiryLead = 'Enquiry/Lead',
    FullApplication = 'Full Application',
    LocatingLender = 'Locating Lender',
    LocatingGuarantor = 'Locating Guarantor',
    PresentationCall = 'Presentation Call',
    PresentationDone = 'Presentation Done',
    PendingValuationPayment = 'Pending Valuation Payment',
    AwaitingSignatureDocs = 'Awaiting Signature/Docs',
    DocsOut = 'Docs Out',
    AwaitingPack = 'Awaiting Pack', // TODO: Remove this once Signature change deployed
    AwaitingDocs = 'Awaiting Docs',
    DocsIn = 'Docs In',
    Processing = 'Processing',
    ValuationBooked = 'Valuation Booked',
    ValuationDone = 'Valuation Done',
    InLegal = 'In Legal',
    AtLender = 'At Lender',
    LenderOffered = 'Lender Offered',
    CaseFunded = 'Case Funded',
    CommissionReceived = 'Commission Received',
    Cancelled = 'Cancelled',
    BrokerFeePaid = 'Broker Fee Paid',
    WithInsurer = 'With Insurer',
    TermsIssued = 'Terms Issued',
    OnRiskCaseFunded = 'On Risk (Case funded)',
    TBC = 'TBC',
}

export enum SalesPipelineStage {
    Prospect = 'Prospect',
    LeadQualification = 'Lead Qualification',
    ProductSourcing = 'Product Sourcing',
    Proposal = 'Proposal',
    Processing = 'Processing',
    Commitment = 'Commitment',
    Closeout = 'Closeout',
    Won = 'Won',
    Lost = 'Lost',
    OnHold = 'On Hold',
}
